/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// Documentation for contributing to command palette: go/compal
import type { CommandPaletteRegistry } from '@jira/compal__command-palette/src/common/types/index.tsx';

// Alphabetical order please
export const COMMAND_PALETTE_REGISTRY_IDS = {
	ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
	ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
	ASK_ROVO: 'ASK_ROVO',
	CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
	COPY_URL: 'COPY_URL',
	DESCRIPTION: 'DESCRIPTION',
	ISSUE_ACTIONS: 'ISSUE_ACTIONS',
	ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
	ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
	ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
	LOG_WORK: 'LOG_WORK',
	NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
	PARENT: 'PARENT',
	PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
	QUICK_ADD: 'QUICK_ADD',
	QUICK_SEARCH: 'QUICK_SEARCH',
	SHORTCUTS: 'SHORTCUTS',
	STATUS: 'STATUS',
	STORY_POINTS: 'STORY_POINTS',
	TEST: 'TEST',
	THEME_MODE: 'THEME_MODE',
	FORGE: 'FORGE',
} as const;

export type COMMAND_PALETTE_REGISTRY_ID = keyof typeof COMMAND_PALETTE_REGISTRY_IDS;

// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const teams = {
	Deliveroo: 'Deliveroo',
};

// Alphabetical order please
export const COMMAND_PALETTE_REGISTRY: CommandPaletteRegistry<COMMAND_PALETTE_REGISTRY_ID> = {
	ADMIN_NAVIGATION: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.ADMIN_NAVIGATION,
		teamName: teams.Deliveroo,
	},
	ASK_ROVO: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.ASK_ROVO,
		teamName: teams.Deliveroo,
	},
	CHECK_NOTIFICATIONS: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.CHECK_NOTIFICATIONS,
		teamName: teams.Deliveroo,
	},
	COPY_URL: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.COPY_URL,
		teamName: teams.Deliveroo,
	},
	DESCRIPTION: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.DESCRIPTION,
		teamName: teams.Deliveroo,
	},
	ISSUE_ACTIONS: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.ISSUE_ACTIONS,
		teamName: teams.Deliveroo,
	},
	ISSUE_FIELD_ASSIGN: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.ISSUE_FIELD_ASSIGN,
		teamName: teams.Deliveroo,
	},
	ISSUE_HEADER_ACTIONS: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.ISSUE_HEADER_ACTIONS,
		teamName: teams.Deliveroo,
	},
	ISSUE_SUB_HEADER_ACTIONS: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.ISSUE_SUB_HEADER_ACTIONS,
		teamName: teams.Deliveroo,
	},
	LOG_WORK: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.LOG_WORK,
		teamName: teams.Deliveroo,
	},
	NAVIGATION_COMMANDS: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.NAVIGATION_COMMANDS,
		teamName: teams.Deliveroo,
	},
	PARENT: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.PARENT,
		teamName: teams.Deliveroo,
	},
	PROJECT_NAVIGATION: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.PROJECT_NAVIGATION,
		teamName: teams.Deliveroo,
	},
	QUICK_ADD: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.QUICK_ADD,
		teamName: teams.Deliveroo,
	},
	QUICK_SEARCH: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.QUICK_SEARCH,
		teamName: teams.Deliveroo,
	},
	SHORTCUTS: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.SHORTCUTS,
		teamName: teams.Deliveroo,
	},
	STATUS: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.STATUS,
		teamName: teams.Deliveroo,
	},
	STORY_POINTS: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.STORY_POINTS,
		teamName: teams.Deliveroo,
	},
	THEME_MODE: {
		registryId: COMMAND_PALETTE_REGISTRY_IDS.THEME_MODE,
		teamName: teams.Deliveroo,
	},
};
